<template >
  <div class="left-bar">
    <el-col>
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo el-scrollbar-wrap"
        :unique-opened="true"
        router
      >
        <el-scrollbar wrap-class="list" :native="false">
          <!-- 二级菜单循环 -->
          <div v-for="(item, i) in NewMenu" :key="i">
            <!-- 无子菜单 -->
            <el-menu-item :index="item.url" v-if="item.children.length === 0">
              <img :src="item.imgURL" class="icon" />
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
            <!-- 有子菜单 -->
            <el-submenu :index="i + ''" v-if="item.children.length !== 0">
              <template slot="title">
                <img :src="item.imgURL" class="icon" />
                <span>{{ item.name }}</span>
              </template>

              <!-- 三级菜单 -->
              <div v-for="(sub, j) in item.children" :key="j">
                <!-- 无子菜单的 -->
                <el-menu-item :index="sub.url" v-if="sub.children.length === 0">
                  <span slot="title">{{ sub.name }}</span>
                </el-menu-item>

                <!-- 有子菜单的 -->
                <el-submenu
                  :index="i + '-' + j"
                  v-if="sub.children.length !== 0"
                >
                  <template slot="title">
                    <span>{{ sub.name }}</span>
                  </template>
                  <el-menu-item
                    :index="sub3.url"
                    v-for="(sub3, k) in sub.children"
                    :key="i + '-' + j + '-' + k"
                    :class="{ colorred: sub.color === 'red' }"
                    >{{ sub3.name }}</el-menu-item
                  >
                </el-submenu>
              </div>
            </el-submenu>
          </div>
        </el-scrollbar>
      </el-menu>
    </el-col>
  </div>
</template>

<script>
// import { permissionTel } from '@/config.js'
import { mapGetters } from 'vuex'
import { getMenu } from '@/apis/permission.js'
import { isGY } from '@/utils/api'
import { newMenu2, newMenu3 } from './menu.js'
export default {
  name: 'LeftBar',
  data() {
    return {
      menu: [],
      NewMenu: []
    }
  },
  async created() {
    try {
      let res = await getMenu(this.userInfo.userID)
      this.menu = res
      let menu1 = this.menu.filter((item) => item.level === 1 && item.type === 0)
      let menu2 = this.menu.filter((item) => item.level === 2 && item.type === 0)
      let menu3 = this.menu.filter((item) => item.level === 3 && item.type === 0)
      // let accoutShow=this.menu.filter(item => item.name === '结算权限' && item.type===1)
      //this.$store.commit('SET_ACCOUNT',accoutShow.length>0) //结算是否显示
      // menu2 = newMenu2
      //   .slice(0, newMenu2.length - 1)
      //   .concat(menu2)
      //   .concat(newMenu2.slice(newMenu2.length - 1))
      menu2 = newMenu2.concat(menu2)
      menu3 = menu3.concat(newMenu3)
      if (isGY) menu2 = menu2.filter((item) => item.id !== 399 && item.id !== 99999) // 美团活动信息 和 版本控制
      // 老怪兽菜单接口模拟
      menu1.forEach((item) => {
        // 一级目录 6 商品管理
        item.children = []
        menu2.forEach((it2) => {
          it2.children = []
          if (item.id === it2.parentID) {
            item.children.push(it2)
          }
          menu3.forEach((it3) => {
            if (it2.id === it3.parentID) {
              it2.children.push(it3)
            }
          })
        })
      })
      // 
      // console.log('获取菜单信息,,,商品管理',menu1[2])
     
      if(localStorage.getItem('mobile') == '18981810340'){
        menu1[4].children = menu1[4].children.slice(2,menu1[4].children.length-1)
          .concat(menu1[4].children.slice(0,2))
          .concat(menu1[4].children.slice(menu1[4].children.length-1))
      }else{
        // 商品管理
        let findIndex = menu1.findIndex(item => item.id === 6) 
        // console.log('findIndex',findIndex)
        if(findIndex !== -1) menu1[findIndex].children = this.goodsManagerMenu(menu1[findIndex].children)

        // 商品管理
        let findIndex2 = menu1.findIndex(item => item.id === 17) 
        if(findIndex2 !== -1) menu1[findIndex2].children = this.awaitManagerMenu(menu1[findIndex2].children)

        // /门店管理
        let findIndex3 = menu1.findIndex(item => item.id === 27)
        if(findIndex3 !== -1) menu1[findIndex3].children = this.storeManagerMenu(menu1[findIndex3].children)

        // 营销活动
        let findIndex4 = menu1.findIndex(item => item.id === 39)
        if(findIndex4 !== -1) menu1[findIndex4].children = this.activeManagerMenu(menu1[findIndex4].children)

        // 财务
        let findIndex5 = menu1.findIndex(item => item.id === 42)
        if(findIndex5 !== -1) menu1[findIndex5].children = this.financialManagerMenu(menu1[findIndex5].children)
      }
     
      this.NewMenu = menu1
    } catch (error) {}
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      yunyingMap: 'yunyingMap'
    })
  },
  methods: {
    // 整理商品管理类目
    goodsManagerMenu(menu){
      let arr = []
      arr = menu.filter((item) => item.id !== 77) // 删除京东分类管理
      arr.map(item => {
        if(item.id === 10){
          // 门店商品管理
          item.seq = 1
        }else if(item.id === 11){ 
          // 门店商品修改审核
          item.seq = 2
        }else if(item.id === 8){ 
          // 门店分类管理
          item.seq = 3
        }else if(item.id === 9){ 
          // 商品水印前缀管理
          item.seq = 4
        }else if(item.id === 12){ 
          // 京西门店商品复制到京西
          item.seq = 5
        }else if(item.id === 13){ 
          // 门店商品可售状态修改
          item.seq = 6
        }else if(item.id === 14){ 
          // 门店商品关注可售改价
          item.seq = 7
        }else if(item.id === 16){ 
          // 单门店商品批量修改
          item.seq = 8
        }else if(item.id === 15){ 
          // 根据城市查询推荐商品
          item.seq = 9
        }else if(item.id === 7){ 
          // 京西商品及分类管理
          item.seq = 10
        }
      })
      return arr.sort((a, b) => {
        return a.seq - b.seq;
      })
    },
    // 整理同步管理类目 
    awaitManagerMenu(menu) { 
      let arr = []
      arr = menu.filter((item) => item.id === 18 || item.id === 19 || item.id === 23)
      arr.map(item => {
        if(item.id === 18){ 
          // "京西门店商品同步到平台"
          item.seq = 2
        }else if(item.id === 19){ 
          // "初始化门店商品(会删除平台商品)"
          item.seq = 1
        }else if(item.id === 23){ 
          // 美团力荐设置
          item.seq = 3
        }
      })
      return arr.sort((a, b) => {
        return a.seq - b.seq;
      })
    },
    // 门店管理类目
    storeManagerMenu(menu) { 
       let arr = []
      arr = menu.filter((item) => item.id !== 30 && item.id !== 32 && item.id !== 33 && item.id !== 99 && item.id !== 7846)
      arr.map(item => {
        if(item.id === 28){ 
          // "京西门店管理"
          item.seq = 1
        }else if(item.id === 29){ 
          // "门店评分"
          item.seq = 2
        }else if(item.id === 34){ 
          // "发送消息"
          item.seq = 3
        }else if(item.id === 72){ 
          // "品牌管理"
          item.seq = 4
        }else if(item.id === 79){ 
          // "平台账号管理"
          item.seq = 5
        }else if(item.id === 7845){ 
          // "门店聊天管理"
          item.seq = 6
        }else if(item.id === 31){
          // "门店价格评分"
          item.seq = 7
        }else if(item.id === 106){ // 7850
          // 免运包 / 免运费
          item.seq = 8
        }else if(item.id === 107){ // 7851
          // 价格包
          item.seq = 9
        }else if(item.id === 7852){ 
          // 评论回复模板
          item.seq = 10
        }
      })
      return arr.sort((a, b) => {
        return a.seq - b.seq;
      })
    },
    // 营销活动管理类目
    activeManagerMenu(menu){
      let arr = menu
      menu.map(item => {
        if(item.id === 399){ 
          // 美团活动信息
          item.seq = 3
        }else if(item.id === 40){ 
          // "活动管理"
          item.seq = 1
        }else if(item.id === 41){ 
          // "活动创建"
          item.seq = 2
        }
      })
      return arr.sort((a,b) => a.seq - b.seq)
    },
    // 财务管理类目
    financialManagerMenu(menu) { 
      let arr = menu
      menu.map(item => {
        if(item.id === 7847){ 
          // "收银台"
          item.seq = 4
        }else if(item.id === 7848){ 
          // "拉卡拉商户"
          item.seq = 5
        }else if(item.id === 7849){ 
          // "结算统计"
          item.seq = 2
        }else if(item.id === 43){ 
          // "门店账单推送"
          item.seq = 1
        }else if(item.id === 7853){ 
          // "考核统计"
          item.seq = 3
        }
      })
      return arr.sort((a,b) => a.seq - b.seq)
    },
    // 交换变量
    swapArrayElements(arr, indexA, indexB) {
        
    },
    // 点击相同router-link 刷新组件
    clickLink(path) {
      // this.$root.reload()
      // this.$emit('reload')
      this.$store.dispatch('RefreshPage', false)
      this.$nextTick(() => {
        this.$store.dispatch('RefreshPage', true)
      })
      // this.$router.push({
      //   path,
      //   query: {
      //     t: +new Date() // 保证每次点击路由的query项都是不一样的，确保会重新刷新view
      //   }
      // })
    }
  }
}
</script>

<style lang="scss">
.left-bar {
  .el-col {
    // width: 50px;
    // overflow: hidden;
    height: calc(100vh - 63px);
  }
  .icon {
    width: 16px;
    margin-right: 10px;
  }
  .el-scrollbar-wrap {
    width: 230px;
    height: 100%;
    overflow: hidden;
    // margin-top: 1px;
  }
  .el-menu-item-group {
    .el-menu-item {
      line-height: 1.2;
      padding: 10px 10px;
      padding-left: 10px !important;
      margin-left: 30px;
      border-left: 1px solid #e4e7ed;
      height: auto;
      white-space: normal;
      &:hover {
        background: none;
        color: #1989fa;
      }
      &:focus {
        background: none;
        color: #1989fa;
      }
    }
    .is-active {
      // font-weight: bold;
      border-left: 3px solid #1989fa;
      color: #1989fa;
    }
  }
  // 高亮文字
  .highlight {
    // color: #409EFF;
    vertical-align: inherit;
  }
  // 滚动区域高度，超过这个高度，出现滚动条
  .list {
    max-height: calc(100vh - 63px);
  }
  // 滚动条颜色
  .el-scrollbar__thumb {
    background: #ccc;
  }
  .colorred {
    color: #f56c6c;
    &:hover {
      color: red !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu/leftbarnew.vue